const URL = {
  MEDIA_DIRECTORY_GET_ROOT: 'Media/GetRootDirectory',
  MEDIA_DIRECTORY_GET: 'Media/GetDirectory',
}

export default URL
